import './AgentHome.css';
import { forwardRef, useRef, useState } from 'react';
import { Loading } from '@icp/components';
import { selectUserProfile } from 'store/features/authSlice';
import { useSelector } from 'react-redux';

import GeneralAIAgent from '../../GeneralAIAgent';
import AIAgentWelcomePage from './WelcomePage';

const Step = {
  WELCOME: 'WELCOME',
  INITIAL: 'INITIAL',
};

const LandingPageAI = forwardRef((props, ref) => {
  const [step, setStep] = useState(Step.WELCOME);
  const userProfile = useSelector(selectUserProfile);
  const generalAgentRef = useRef();
  const [currentAgent, setCurrentAgent] = useState(null);

  const handleNewChatStarted = () => {
    setStep(Step.WELCOME);
  };

  return userProfile ? (
    <div className="landing-page-ai" ref={ref}>
      {step === Step.WELCOME ? (
        <AIAgentWelcomePage
          onStartChat={(prompt) => {
            setStep(Step.INITIAL);
            generalAgentRef.current?.sendMessage(prompt);
          }}
          agentInfo={currentAgent}
          handleSessionSelected={(session) => {
            generalAgentRef.current?.setActiveView?.('session');
            generalAgentRef.current?.setCurrentSession?.(session);
            setStep(Step.INITIAL);
          }}
        />
      ) : null}
      <div
        className="landing-initial-page-container"
        style={{ display: step === Step.WELCOME ? 'none' : 'block' }}
      >
        <div className="landing-initial-page">
          <div className="landing-chat-message">
            <GeneralAIAgent
              ref={generalAgentRef}
              hideFloatButton={true}
              onAgentChanged={(agent) => {
                setCurrentAgent(agent);
              }}
              eventHandlers={{ onNewChatStarted: handleNewChatStarted }}
              agentListConfiguration={{ defaultFirstAgent: true }}
            />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <Loading />
  );
});

export default LandingPageAI;
